import { companyApis } from '@apis/dashboard/companyApis';
import { useMutation } from '@hooks/useMutation';
import type { PatchCompany } from '@models/Company';
import { useQueryClient } from '@tanstack/react-query';
import { FormError } from '@utils/errors';

export const usePatchCompany = (id: number) => {
  const queryClient = useQueryClient();

  return useMutation(
    async (body: PatchCompany) => {
      const response = await companyApis.patch('/dashboard/company/{id}/detail/', {
        path: { id },
        body,
      });
      if (response[400]) {
        throw new FormError('PatchCompany', response[400]);
      }
      return response[200]!;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([`/dashboard/company/${id}/`]);
        queryClient.invalidateQueries([`/dashboard/company/${id}/detail/`]);
        queryClient.invalidateQueries([`/dashboard/company/${id}/`]);
        queryClient.invalidateQueries({
          predicate: (q) => q.queryKey[0] === '/dashboard/route-plan/',
        });
      },
    },
  );
};
